export default function LocalizedInput({
  control,
  fields, // [{ nameBase, label, component: Comp, props }]
  mainLanguage = "en",
  otherLanguages = [],
  disabled,
  size = "sm",
}) {
  // This is to handle the case when otherLanguages is undefined or null
  const languages = [mainLanguage, ...(otherLanguages ?? [])];

  // If there is only one language, we don't need to show the language in label
  const showLanguageInLabel = languages.length > 1;

  return (
    <>
      {languages.map((lang) =>
        fields.map(({ nameBase, label, component: Comp, props = {} }) => {
          const labelText =
            typeof label === "function"
              ? label(lang)
              : `${label} ${showLanguageInLabel ? `(${lang.toUpperCase()})` : ""}`;

          const extraProps = typeof props === "function" ? props(lang) : props;

          return (
            <Comp
              key={`${nameBase}-${lang}`}
              label={labelText}
              name={`${nameBase}.${lang}`}
              control={control}
              disabled={disabled}
              size={size}
              {...extraProps}
            />
          );
        })
      )}
    </>
  );
}
